import { render } from "./empty-start-review-message.vue?vue&type=template&id=611aef18&ts=true"
import script from "./empty-start-review-message.ts?vue&type=script&lang=ts&external"
export * from "./empty-start-review-message.ts?vue&type=script&lang=ts&external"

import "./empty-start-review-message.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__